import { NgSelectModule } from '@ng-select/ng-select';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule , ReactiveFormsModule } from '@angular/forms';
import { Component, Input, Output, EventEmitter, } from "@angular/core";

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, RouterModule, TranslateModule, NgSelectModule],
  selector: "mapfre-switch",
  templateUrl: "./mapfre-switch.component.html"
})
export class MapfreSwitchComponent {
  @Input() copyLeft:      boolean;
  @Input() copyRight:     boolean;
  @Input() setStatus:     boolean;
  @Output() switchOn:     EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() isDisabled = false;

  switchValueOnOff(e) {
    let bool;
    if(e.target.checked) {
      bool = true;
    }
    else {
      bool = false;
    }
    this.switchOn.emit(bool);
  }
}
